export default __webpack_public_path__ + "static/media/12_wiosna.53d85baa.png";